module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well"
  }, [_c('div', {
    staticClass: "pomodoro-timer"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("leftpad")(_vm.min)) + ":" + _vm._s(_vm._f("leftpad")(_vm.sec)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0600d9eb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CountdownComponent.vue
// module id = 49
// module chunks = 2